import { createClient, SupabaseClient } from '@supabase/supabase-js'

// Use import.meta.env for Vite environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

console.log('🔑 Supabase URL available:', !!supabaseUrl);
console.log('🔑 Supabase Anon Key available:', !!supabaseAnonKey);

// Create Supabase client with fallback values if env vars are missing
let supabase: SupabaseClient;
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables');
  // Don't throw error in production, use fallback values
  const fallbackUrl = 'https://example.supabase.co';
  const fallbackKey = 'fallback-key';
  
  console.warn('⚠️ Using fallback Supabase credentials');
  
  supabase = createClient(fallbackUrl, fallbackKey);
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
}

export { supabase };

// Type for user roles
export type UserRole = 'driver' | 'dispatcher' | 'admin' | 'super-admin'

// Type for user metadata
export interface UserMetadata {
  role: UserRole
}

// Helper to get user role from session
export const getUserRole = async (): Promise<UserRole | null> => {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    return session?.user?.user_metadata?.role || null
  } catch (error) {
    console.error('Error getting user role:', error);
    return null;
  }
} 